// export const BACKEND_URL = "http://localhost:5000";
export const BACKEND_URL = "https://www.unterberg-duathlon.at/api";
